import { render, staticRenderFns } from "./VideoContentList.vue?vue&type=template&id=362eb9bc&"
import script from "./VideoContentList.vue?vue&type=script&lang=js&"
export * from "./VideoContentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports